import React from 'react';
import { Dialog } from '@mui/material';
import { useTheme } from '@ublend-npm/aulaui-core';
import PostDetail from './PostDetail';

export interface PostDetailPopupProps {
  item: any;
  open: boolean;
  onClose: () => void;
}

const PostDetailPopup: React.FC<PostDetailPopupProps> = ({
  open,
  onClose,
  item,
}) => {
  const theme = useTheme();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      aria-label="Post details"
      PaperProps={{
        sx: {
          bgcolor: theme.palette.background.paper,
          color: theme.palette.text.primary,
          borderRadius: 2,
          maxWidth: '648px',
          height: '85vh',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
        },
      }}
    >
      <PostDetail item={item} onClose={onClose} />
    </Dialog>
  );
};

export default PostDetailPopup;
